// TV runtime entry. The shell (tizen-shell) fetches index.html from the server and
// injects this script; it runs the same way in a browser and in the panel preview.
import * as preact from 'preact';
import * as hooks from 'preact/hooks';
import * as jsxRuntime from 'preact/jsx-runtime';
import * as sdk from '@frame/sdk/tv';
import { App } from './App.tsx';
import { Runtime } from './runtime.ts';
import { initNav } from './nav.ts';
import { releaseAudio, unlockAudio } from './audio.ts';

// Widget bundles use this single copy of preact and the SDK (the build pipeline wires them up).
(window as any).__frame = { preact, 'preact/hooks': hooks, 'preact/jsx-runtime': jsxRuntime, '@frame/sdk/tv': sdk };

const base = new URL('.', import.meta.url).href;
const rt = new Runtime(base);
(window as any).__frameRuntime = rt;

window.addEventListener('error', (e) => rt.log('error', `${e.message} @${e.filename}:${e.lineno}`));
window.addEventListener('unhandledrejection', (e) => rt.log('error', `promise: ${(e.reason && e.reason.stack) || e.reason}`));

// In the gallery the first key press only wakes the TV; it doesn't reach the tile behind.
window.addEventListener(
  'keydown',
  (e) => {
    unlockAudio();
    if (rt.mode() === 'idle') {
      e.preventDefault();
      e.stopImmediatePropagation();
      rt.wake();
    } else rt.resetIdle();
  },
  true,
);
// In a browser (panel preview) a mouse click also unlocks audio.
window.addEventListener('pointerdown', unlockAudio, true);
initNav(() => rt.back());

// Coming back from another app opens in launcher mode.
// Going to the background (another app came to the front) releases the audio output.
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') rt.wake();
  else releaseAudio();
});

document.body.innerHTML = '';
rt.initMode();
preact.render(<App rt={rt} />, document.body);
rt.connect();
